import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {ButtonModule} from "../../../shared/component/common/button/button.module";
import {LabelModule} from "../../../shared/component/common/label/label.module";
import {RadioModule} from "../../../shared/component/common/radio/radio.module";
import {RetryModule} from "../../../shared/component/common/retry/retry.module";
import {OverviewErrorComponent} from "./overview-error.component";
import {HeaderModule} from "../../../shared/component/common/header/header.module";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    RadioModule,
    RetryModule,
  ],
  declarations: [OverviewErrorComponent]
})
export class OverviewErrorModule { }
